<template>
  <div class="main-container">
    <div style="width: 100%;">
      <div class="table-header-custom">
        <el-input
          style="max-width: 400px"
          placeholder="Type something"
          prefix-icon="el-icon-search"
          v-model="searchTerm"
        ></el-input>
        <can I="create" a="customer">
          <router-link to="/customer/new">
            <el-button type="primary">New Customer</el-button>
          </router-link>
        </can>
      </div>
      <!-- {{contactList}} -->
      <vue-good-table
        :columns="fields"
        :rows="usersList"
        :search-options="{
          enabled: true,
          searchFn: searchTable,
          externalQuery: searchTerm
        }"
        :pagination-options="{ enabled: true }"
      >
        <template
          slot="table-row"
          slot-scope="props"
          @click.stop="navTo(details[0], props.row.id)"
        >
          <!-- {{1}} -->
          <span v-if="props.column.field == 'full_name'"
            >{{ props.row.firstName }} {{ props.row.lastName }}</span
          >
          <span v-if="props.column.field == 'gender'">{{
            props.row.gender + "" === "0" ? "Female" : "Male"
          }}</span>
          <span v-else-if="props.column.field == 'actions'">
            <!-- <b-button-group> -->
            <!-- <b-button variant="success" @click.stop="navTo(details[1],props.row.id)">Role</b-button> -->
            <el-button
              size="md"
              type="primary"
              plain
              @click.stop="navTo(details[0], props.row.id)"
              >Details</el-button
            >
            <!-- <b-button
                variant="outline-primary"
                @click.stop="navTo(details[0],props.row.id)"
            >Details</b-button>-->
            <!-- </b-button-group> -->
          </span>
          <span v-else>{{ props.row[props.column.field] }}</span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import moment from "moment";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem
  // ...
} from "element-ui";
// import { ZOHOTHTTP } from "../../../store/actions";
// https://www.zohoapis.com/crm/v2
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { debug } from "util";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  name: "customers",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem
  },
  data() {
    return {
      zohoToken: {},
      contactList: [],
      usersList: [],
      form: {
        // links: [],
        contact: "",
        invoiceType: "",
        price: "",
        desc: ""
      },

      searchTerm: "",
      selectOption: {
        enabled: true
      },
      items: items,
      fields: [
        {
          field: "id",
          label: "ID",
          sortable: "true"
        },
        {
          field: "full_name",
          label: "Full Name",
          sortable: "true"
        },
        {
          field: "roleType",
          label: "User Type",
          sortable: "true"
        },
        {
          field: "email",
          label: "E-mail",
          sortable: "true"
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: "gender",
          label: "Gender",
          sortable: "true"
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: "phoneNumber",
          label: "Phone Number",
          sortable: "true"
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: "updatedAt",
          label: "Last Seen",
          sortable: "true"
        },
        {
          field: "actions",
          label: "Actions"
        }
      ],
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices"
    ]),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  methods: {
    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchUsers() {
      const HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      const url =
        `/users?filter[include][installations]=deviceRequest&filter[include][installations]=deviceType&filter[where][roleType]=customer` +
        `&filter[order]=id DESC`;
      HTTP.get(url)
        .then(response => {
          this.usersList = response.data;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    // querySearch(queryString, cb) {
    //   var links = this.form.links;
    //   var results = queryString
    //     ? links.filter(this.createFilter(queryString))
    //     : links;
    //   // call callback function to return suggestions
    //   cb(results);
    // },
    // createFilter(queryString) {
    //   return link => {
    //     return (
    //       link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    //     );
    //   };
    // },
    loadAll() {
      console.log("++++++++++++++++++++++++++");
      // console.log(this.zohoToken);
      const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      let container = this;
      ZOHOTHTTP.get(`fetchAll`, {
        params: {
          collection: "Contacts?fields=Email,Full_Name,Phone"
        }
      })
        .then(response => response.data["result"]["data"])
        .then(tempList => {
          container.contactList = tempList.map(x => ({
            ...x,
            value: x.Full_Name
          }));
        })
        .catch(e => {
          console.log("========Err=========");
          console.log(e);
          // this.refreshZohoToken();
        });
    },
    // querySearchAsync(queryString, cb) {
    //   var links = this.links;
    //   var results = queryString
    //     ? links.filter(this.createFilter(queryString))
    //     : links;
    //   clearTimeout(this.timeout);
    //   this.timeout = setTimeout(() => {
    //     cb(results);
    //   }, 3000 * Math.random());
    // },
    createFilter(queryString, contact) {
      return (
        contact.Full_Name.toLowerCase().indexOf(queryString.toLowerCase()) > -1
      );
    },
    contactSearch(queryString, cb) {
      let contacts = this.contactList;
      var results = queryString
        ? contacts.filter(contact => this.createFilter(queryString, contact))
        : contacts;
      cb(results);
    },
    onSubmit() {
      console.log(this.form.links);
    },
    async fetchZohoToken() {
      const HTTP = this.$httpUtils.instance;
      return await HTTP.get("/zohos/get-zoho-token");
    },
    async refreshZohoToken() {
      const HTTP = this.$httpUtils.instance;
      let newToken = await HTTP.post("/zohos/refresh-zoho-token");
      this.zohoToken = newToken.data.token;
      this.loadAll();
    }
  },
  async mounted() {
    this.fetchUsers();
    this.loadAll();
    // console.log(this.zohoToken);
  }
};
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}

.customer-btn {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/users/customers.vue